export default {
  colors: {
    primary: "#2991D6",
    green: "#2FAF9F",
    red: "#DC3545"
  },
  font: "Quicksand"
}